class UserClientFunctionalities {
	constructor(permission, http, helper, API) {
		this.permission = permission;
		this.http = http;
		this.helper = helper;
		this.API = API;
	}

	getItems() {
		return this.http({
			...this.helper.http(this.API.userClientFunctionalities, 'GET'),
			params: {
				idFuncionalidade: -32
			}
		});
	}
}
export default UserClientFunctionalities;
